import { getResultsList, getSolutionProfile } from '@/infrastructure/api-functions';
import type { IBaseSolution, IOneProfileRequest, ISrpRequest, IdeaContent } from '@/types';
import { findIndex } from 'lodash'
import { ref } from 'vue';
import { reportService } from '@/services/report-service'
import { i18n } from '@/infrastructure/locales'
import { EActivityTriggerType } from '@eureka/services/src/types/activity-type';
import { withFieldLoading } from '@eureka/utils/task'
import { hookErrorCode } from '@eureka/services/src/custom-error-handler'
import { Toast } from 'patsnap-biz';

const LIMIT_SEARCH = 90112031

const getProfile = (data: IOneProfileRequest) => {
    return getSolutionProfile(data).then((profile) => {
        if (profile) {
            return profile as IBaseSolution
        } else {
            return null;
        }
    })
}

export class IdeaResult {
    results: IBaseSolution[] = []

    getResultLoading = false

    searchCounts = 0

    getResults(data: ISrpRequest) {
        this.searchCounts++;
        const task = getResultsList(data).then(({ items, lang }) => {
            this.results = items.map((r) => {
                return {
                    ...r,
                    addedReport: false,
                    manualAddIntoResult: false,
                }
            });
            return {
                lang,
                items,
            }
        })
        const task2 = hookErrorCode(task, [LIMIT_SEARCH], (error) => {
            import('@eureka/shared/upgrade-activity').then((mod) => {
                mod.openUpgradeActivity(i18n, { activityTriggerType: EActivityTriggerType.idea, error })
            })
        })
        return withFieldLoading(this, task2, 'getResultLoading');
    }

    /**
     * 用户手动切换勾选状态
     */
    toggleIntoReportList(solution: IBaseSolution) {
        try {
            solution.addedReport ? reportService.value.removeChosen(solution) : reportService.value.add(solution)
            solution.addedReport = !solution.addedReport
        } catch (error) {
        }
    }

    /**
     * 通过专利号对比
     */
    liftByPatentNumber(solutionId: string) {
        const currentSolutionIndex = findIndex(this.results, {
            patent_id: solutionId,
        })
        if (currentSolutionIndex >= 0) {
            Toast({
                message: i18n.global.t('alreadyInList', { index: currentSolutionIndex + 1 }),
                type: 'warning',
            })
            this.results[currentSolutionIndex].manualAddIntoResult = true
            setTimeout(() => {
                const patentCard = document.querySelector(`.idea-solution-card[data-patent-id="${solutionId}"]`);
                patentCard?.scrollIntoView({ behavior: 'smooth' });
            }, 0);
            return;
        }
        const firstResult: IBaseSolution = {
            patent_id: solutionId,
            addedReport: false,
            manualAddIntoResult: true,
        }
        this.results = [firstResult, ...this.results]
    }

    getSolutionProfile(solutionBase: IBaseSolution, editData: IdeaContent): Promise<Nullable<IBaseSolution>> {
        return getProfile({
            patent_id: solutionBase.patent_id,
            means: editData.means,
            efficacy: editData.efficacy,
        }).then(
            r => {
                const currentIndex = this.results.findIndex(f => f.patent_id === solutionBase?.patent_id)
                if (!r || currentIndex < 0) return null
                /**
                 * 针对异步获取信息的卡片，需要将异步信息更新到results数组里，报告弹窗才能获取到标题等信息
                 */
                this.results[currentIndex] = {
                    ...this.results[currentIndex],
                    ...r,
                };
                return this.results[currentIndex]
            }
        ).finally(() => {

        })
    }
}
export const ideaResult = ref<IdeaResult>(new IdeaResult())
